import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-info',
  templateUrl: './info.component.html',
  styleUrls: ['./info.component.css']
})
export class InfoComponent implements OnInit {

  @Input() object: any;
  public richText: any;

  constructor() { }

  ngOnInit(): void {
    console.log(this.object);
    this.richText = this.object.textresponse;
  }

}
